<template>
  <div>
    <section-title
      content="Información de Contacto Primario"
      :has-line="true"
    />
    <div class="p-3">
      <div class="mx-2">
        <div class="row">
          <div class="col-md-4">
            <validation-provider
              v-slot="{ errors }"
              name="primaryContactInfoName"
              rules="required"
            >
              <custom-input
                v-model="model.nameFirst"
                :custom-error-msg="'El nombre es requerido.'"
                :error="errors[0]"
                label="Nombre:"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <validation-provider
              v-slot="{ errors }"
              name="primaryContactInfoPaternalLastName"
              rules="required"
            >
              <custom-input
                v-model="model.nameLastPaternal"
                :custom-error-msg="'El apellido paterno es requerido.'"
                :error="errors[0]"
                label="Apellido Paterno:"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <custom-input
              v-model="model.nameLastMaternal"
              label="Apellido Materno:"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-4">
            <validation-provider
              v-slot="{ errors }"
              name="primaryContactInfoDepartment"
            >
              <custom-input
                v-model="model.department"
                :custom-error-msg="'El departamento es requerido.'"
                :error="errors[0]"
                label="Departamento:"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <validation-provider
              v-slot="{ errors }"
              name="primaryContactInfoPosicion"
            >
              <custom-input
                v-model="model.position"
                :custom-error-msg="'La posición es requerida.'"
                :error="errors[0]"
                label="Posición:"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <validation-provider
              v-slot="{ errors, failedRules }"
              name="primaryContactInfoEmail"
              rules="email"
            >
              <custom-input
                v-model="model.email"
                :custom-error-msg="
                  failedRules['email']
                    ? 'El correo electrónico no es válido.'
                    : ''
                "
                :error="errors[0]"
                label="Correo Electrónico:"
                type="email"
              />
            </validation-provider>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-4">
            <validation-provider
              ref="homePhone"
              v-slot="{ errors }"
              name="homePhone"
              :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
            >
              <label class="data-title mb-0">Hogar:</label>
              <custom-input
                v-model="model.homePhone"
                :custom-error-msg="'El teléfono del hogar es requerido.'"
                :error="errors[0]"
                :mask-type="'Phone'"
                placeholder="(___)___-____"
                @input="validateField"
              />
            </validation-provider>
          </div>

          <div class="col-md-4">
            <validation-provider
              ref="workPhone"
              v-slot="{ errors }"
              name="workPhone"
              :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
            >
              <label class="data-title mb-0">Trabajo:</label>
              <custom-input
                v-model="model.workPhone"
                :custom-error-msg="'El teléfono trabajo es requerido.'"
                :error="errors[0]"
                :mask-type="'Phone'"
                placeholder="(___)___-____"
                @input="validateField"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <validation-provider
              ref="cellPhone"
              v-slot="{ errors }"
              name="cellPhone"
              :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
            >
              <label class="data-title mb-0">Celular:</label>
              <custom-input
                v-model="model.cellPhone"
                :custom-error-msg="'El teléfono celular es requerido.'"
                :error="errors[0]"
                :mask-type="'Phone'"
                placeholder="(___)___-____"
                @input="validateField"
              />
            </validation-provider>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-4">
            <validation-provider
              ref="fax"
              v-slot="{ errors }"
              name="fax"
              :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
            >
              <label class="data-title mb-0">Fax:</label>
              <custom-input
                v-model="model.fax"
                :custom-error-msg="'El fax es requerido.'"
                :error="errors[0]"
                :mask-type="'Phone'"
                placeholder="(___)___-____"
                @input="validateField"
              />
            </validation-provider>
          </div>

          <div class="col-md-4">
            <custom-input
              v-model="model.workPhoneExt"
              label="Ext:"
              :mask-type="'PhoneExt'"
              placeholder="_____"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate';
import SectionTitle from 'SectionTitle';
import CustomInput from 'CustomInput';

export default {
  name: 'LocationServiceContactInfo',
  components: {
    ValidationProvider,
    CustomInput,
    SectionTitle,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    isSomePhoneFilledUp() {
      const cellPhone = Boolean(this.model.cellPhone);
      const workPhone = Boolean(this.model.workPhone);
      const fax = Boolean(this.model.fax);
      const homePhone = Boolean(this.model.homePhone);
      return cellPhone || workPhone || fax || homePhone;
    },
  },
  methods: {
    validateField() {
      if (!this.isSomePhoneFilledUp) {
        this.$refs['cellPhone'].reset();
        this.$refs['workPhone'].reset();
        this.$refs['fax'].reset();
        this.$refs['homePhone'].reset();
      }
    },
  },
};
</script>

<style lang="scss">
.custom-lsci-header-icon {
  font-size: 17pt !important;
  height: 25px;
  width: 33px;
}
</style>
